import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthRoute = ({ children }) => {
  const { userInfo } = useSelector((state) => state?.users?.userAuth);

  // Redirect to login if the user is not logged in
  return userInfo ? children : <Navigate to="/login" replace />;
};

export default AuthRoute;
